import React, { useCallback, useState } from 'react';
import Cropper from 'react-easy-crop';
import 'react-easy-crop/react-easy-crop.css';
import { TARGET_RATIO } from '../../../../utils/creativeAspectRatio';
import './CreativeEditorModal.css';

export default function CreativeCropModal({ slot, imageSrc, onCancel, onNext, exporting }) {
    const aspect = TARGET_RATIO[slot];
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [rotation, setRotation] = useState(0);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const onCropComplete = useCallback((_croppedArea, croppedPixels) => {
        setCroppedAreaPixels(croppedPixels);
    }, []);

    const handleRotate = () => {
        setRotation((prev) => (prev + 90) % 360);
    };

    const handleNext = () => {
        if (!croppedAreaPixels) {
            return;
        }
        onNext({ croppedAreaPixels, rotation });
    };

    return (
        <>
            <div className="creativeEditorModal creativeCropModal" role="dialog" aria-modal="true" aria-labelledby="creative-crop-title">
                <div className="creativeEditorHeader">
                    <button type="button" className="creativeEditorBackBtn" onClick={onCancel} aria-label="Back">
                        ←
                    </button>
                    <h2 id="creative-crop-title" className="creativeEditorTitle">Crop your ad</h2>
                    <span className="creativeEditorHeaderSpacer" aria-hidden="true" />
                </div>

                <div className="creativeCropStage">
                    <Cropper
                        image={imageSrc}
                        crop={crop}
                        zoom={zoom}
                        rotation={rotation}
                        aspect={aspect}
                        onCropChange={setCrop}
                        onZoomChange={setZoom}
                        onRotationChange={setRotation}
                        onCropComplete={onCropComplete}
                        objectFit="contain"
                    />
                </div>

                <div className="creativeCropControls">
                    <label className="creativeZoomLabel" htmlFor="creative-zoom-range">
                        Zoom
                    </label>
                    <input
                        id="creative-zoom-range"
                        type="range"
                        min={1}
                        max={3}
                        step={0.01}
                        value={zoom}
                        onChange={(e) => setZoom(Number(e.target.value))}
                        className="creativeZoomRange"
                    />
                    <button type="button" className="creativeRotateBtn" onClick={handleRotate}>
                        <span className="creativeRotateIcon" aria-hidden="true">↻</span>
                        Rotate
                    </button>
                </div>

                <button
                    type="button"
                    className="creativeEditorPrimaryBtn"
                    onClick={handleNext}
                    disabled={!croppedAreaPixels || exporting}
                >
                    {exporting ? 'Processing…' : 'Next'}
                </button>
            </div>
            <div className="campaignModalBackdrop" />
        </>
    );
}
